module.exports = "<div class=\"row\">\n  <div [class]=\"pdfUrl ? 'col-md-6' : 'col-md-12'\">\n      <img class=\"logo centered\" [src]=\"logo | safeUrl\">\n  </div>\n</div>\n<div id=\"text\" [innerHtml]=\"message | translate\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/buyer-to-seller-wrapper/leapest-message/leapest-message.component.html
// module id = ./src/app/core/components/buyer-to-seller-wrapper/leapest-message/leapest-message.component.html
// module chunks = main